module.exports = __webpack_public_path__ + "public/img/img_android_down_hk_2.9aba218b.png";